import dayjs from 'dayjs';
import { getCookie } from 'common/utils';
// import { getDateByRoute } from 'common/utils';
import { getaoishoplist, getshopinfo, getBrandList } from '../../api';
// console.log(getDateByRoute());
export default {
  state: {
    // 日期选择
    date: new Date(), // 20180929
    AoiShopMode: 2, // 数据维度选项 ： 商圈 1 驻店 2
    loadAoiShopList: true,
    // 商圈店铺列表
    AoiList: [],
    ShopList: [],
    AoiSelected: null,
    ShopSelected: null,
    AoiShopInfo: [],
    ViewMode: 2, // 浏览模式选项 ： 地图 1 列表 2
    baseTimeTemp: 0,
    brandList: [{ id: 0, brand_name: '全部', brand_abbr: '全部' }],
    activeBrandId: 0,
  },
  getters: {
    AoiShopMsg: ({ AoiList, ShopList, AoiSelected, ShopSelected, AoiShopMode }) => {
      const targetlist = AoiShopMode === 1 ? AoiList : ShopList;
      return targetlist[AoiShopMode === 1 ? AoiSelected : ShopSelected];
    },
  },
  mutations: {
    setAsideState(state, payload) {
      // 更新state
      Object.keys(payload).forEach((item) => {
        state[item] = payload[item];
      });
    },
    setBaseTimeTemp(state, payload) {
      state.baseTimeTemp = new Date(payload).getTime();
    },
  },
  actions: {
    // 设置商圈店铺默认选项
    setDefaultSelect({ commit, state, dispatch }) {
      const { AoiShopMode, AoiList, ShopList } = state;
      if (AoiList.length > 0 || ShopList.length > 0) {
        // 如果当前列表为空 则切换商圈/驻店选项, 不为空则设第一个为选中项
        if (AoiShopMode === 1) {
          if (AoiList.length === 0) {
            commit('setAsideState', { AoiShopMode: 2 });
            dispatch('handleChangeAoiShopMode', 2);
          } else {
            dispatch('handleChangeAoiShopMode', 1);
          }
        }
        if (AoiShopMode === 2) {
          if (ShopList.length === 0) {
            commit('setAsideState', { AoiShopMode: 1 });
            dispatch('handleChangeAoiShopMode', 1);
          } else {
            dispatch('handleChangeAoiShopMode', 2);
          }
        }
      }
    },
    // 获得商圈、餐厅列表
    requestAoiShopList({ commit, state, dispatch }) {
      const logisticsCenter = getCookie('logisticsCenter');
      const newParams = {
        brand_id: state.activeBrandId,
        type: 'both',
        lc_id: logisticsCenter,
      };
      commit('setAsideState', { loadAoiShopList: true });
      getaoishoplist(newParams).then((res) => {
        const { data } = res;
        // 整合列表数据
        const AoiList = [];
        const ShopList = [];
        if (Array.isArray(data)) {
          let aoiIndex = 0;
          let shopIndex = 0;
          data.forEach((item) => {
            if (item.type === 'aoi') {
              AoiList.push({
                index: aoiIndex,
                aoi_id: item.id,
                label: item.name,
              });
              aoiIndex++;
            }
            if (item.type === 'shop') {
              ShopList.push({
                index: shopIndex,
                shop_id: item.id,
                label: item.name,
              });
              shopIndex++;
            }
          });
        }
        const commitData = {
          AoiList,
          ShopList,
          loadAoiShopList: false,
        };
        if (AoiList.length === 0) {
          commitData.AoiSelected = null;
        } else {
          commitData.AoiSelected = 0;
          // dispatch('handleSelectAoi', 0);
        }
        if (ShopList.length === 0) {
          commitData.ShopSelected = null;
        } else {
          commitData.ShopSelected = 0;
          // dispatch('handleSelectShop', 0);
        }
        if (commitData.ShopSelected === null && commitData.ShopSelected === null) {
          commitData.AoiShopInfo = [];
        }
        commit('setAsideState', commitData);
        dispatch('setDefaultSelect');
      });
    },
    requestBrandList({ commit }) {
      const logisticsCenter = getCookie('logisticsCenter');
      getBrandList({ lc_id: logisticsCenter })
        .then((res) => {
          if (res.errno === 0) {
            commit('setAsideState', {
              brandList: res.data,
            });
          }
        });
    },
    // 获取某个共享商圈店铺详细信息
    requestAoiShopInfo({ commit, getters }) {
      const { AoiShopMsg } = getters;
      if (AoiShopMsg) {
        getshopinfo({
          aoi_id: AoiShopMsg.aoi_id,
          shop_id: AoiShopMsg.shop_id,
        }).then((data) => {
          if (data && Array.isArray(data.data)) {
            data.data.forEach((shop) => {
              shop.shop_position = JSON.parse(shop.shop_position);
              if (shop.polygon !== null && shop.polygon !== '') {
                shop.polygon = JSON.parse(shop.polygon);
              }
            });
            commit('setAsideState', {
              AoiShopInfo: data.data,
            });
          }
        });
      }
    },
    // 选择某个共享单元or店铺
    handleSelectAoi({ commit, dispatch }, selected) {
      commit('setAsideState', {
        AoiSelected: selected,
      });
      dispatch('requestAoiShopInfo');
    },
    handleSelectShop({ commit, dispatch }, selected) {
      commit('setAsideState', {
        ShopSelected: selected,
      });
      dispatch('requestAoiShopInfo');
    },
    handleSelectBrand({ commit, dispatch }, selected) {
      commit('setAsideState', {
        activeBrandId: selected,
        AoiSelected: null,
        ShopSelected: null,
      });
      dispatch('requestAoiShopList');
    },
    // 更改数据来源 [ 共享 / 驻店 ]
    handleChangeAoiShopMode({ commit, state, dispatch }, selected) {
      // 更改 state
      const commitData = { AoiShopMode: selected };
      if (state.AoiList.length === 0) {
        commitData.AoiSelected = null;
      } else {
        commitData.AoiSelected = 0;
      }
      if (state.ShopList.length === 0) {
        commitData.ShopSelected = null;
      } else {
        commitData.ShopSelected = 0;
      }
      if (commitData.ShopSelected === null && commitData.ShopSelected === null) {
        commitData.AoiShopInfo = [];
      }
      commit('setAsideState', commitData);
      if (selected === 1 && commitData.AoiSelected === 0) {
        dispatch('handleSelectAoi', 0);
      } else if (selected === 2 && commitData.ShopSelected === 0) {
        dispatch('handleSelectShop', 0);
      }
    },
    // 更改浏览模式 [ 地图 / 列表 ]
    handleChangeViewMode({ commit }, selected) {
      // 更改 state
      commit('setAsideState', {
        ViewMode: selected,
      });
    },
    // 变更日期(时间戳)
    handleChangeDate({ commit }, date) {
      // 转变所选日期至次日5点时间戳
      const newTime = dayjs(date).add(1, 'day').add(5, 'hour').subtract(1, 'second');
      commit('setAsideState', {
        date,
      });
      commit('setBaseTimeTemp', date);
      commit('UPDATE_TIMESTAMP', newTime.unix());
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/store/TravellerAside.js